Ext.define('SA.view.Notices', {
    singleton: true,

    async maybeShow() {
        var notices = SA.User.getNotices(),
            maybeShow = (xtype, notice) => !!notice && Ext.widget({xtype, notice}),
            unreadAutoShowNotices = notices.adHoc.filter(notice => notice.isUnreadAutoShowNotice());

        maybeShow('package-data-removed-popup', notices.packageDataRemoved);
        maybeShow('point-package-downgraded-popup', notices.pointPackageDowngraded);
        maybeShow('tutorial', notices.tutorial);

        for (let notice of unreadAutoShowNotices) {
            await new Promise(resolve => this.showUnreadAutoShowNotice({notice, onDestroyCb: resolve}));
        }
    },

    showUnreadAutoShowNotice({notice, onDestroyCb}) {
        var cmp = Ext.widget({
            xtype: 'notification',
            title: Ext.String.htmlEncode(notice.getTitleText()),
            messageHtml: notice.getMessageHtml()
        });

        cmp.on('destroy', () => {
            notice.markRead();
            SA.model.Notices.acknowledge({id: notice.getId()});

            onDestroyCb();
        });
    }
});